import * as exInput from '../../forms/input';

import * as exUtils from './utils';

// ----------------------------------------------------------------------------

async function demo(config: Record<string, any> = {}): Promise<any> {
    // New Promise
    const promise = new Promise(function (resolve): any {
        // If not using function change, is default
        if (typeof !(config.fnChange === 'function')) {
            //
            config.fnChange = exUtils.eventListener({
                merge: config.change,
                fnSuccess: function (files): any {
                    resolve(files);
                },
            });
        }

        //
        const fnChange = function (evt): void {
            // Function change
            config.fnChange(evt);

            // Input remove
            input.element.remove();
        };

        //
        const fnCancel = function (): void {
            // Input remove
            input.element.remove();
        };

        // Create element (input) (upload)
        const input = exInput.create({
            merge: config.input,
            type: 'file',
            multiple: true,
            attr: {
                hidden: '',
            },
            event: {
                change: fnChange,
                cancel: fnCancel,
            },
        });
        document.body.appendChild(input.element);

        // Input click
        input.element.click();
    });

    // Return
    return promise;
}

// ----------------------------------------------------------------------------

export default demo;
